import * as selectComponent from "../../../../common/ts/components/core/SelectComponent";
import dom from "../../../../common/ts/core/dom";
import location from "../../../../common/ts/core/location";
import serpFiltersModal from "../../serp/filters/filtersModal";
import {EventBus} from "../../../../common/ts/events/EventBus";
import {OperationTypeSelectedEvent} from "./events";
import {getFormDataSubmittingInFilterBar} from "../../serp/filters/filterFormData";

const OPERATION_TYPE_SELECT_ID = 'operation-type-select';

// function updateFormDataAndCurrentSearchParams(formData: {[p: string]: any}, currentSearchParams: URLSearchParams, operationTypeKey: string, newOperationTypeValue: string) {
//     currentSearchParams.set(operationTypeKey, formData[operationTypeKey]);
//     formData[operationTypeKey] = newOperationTypeValue;
// }

function init(filterFormSelector?: string) {
    selectComponent.onChangeFor(OPERATION_TYPE_SELECT_ID, function ({name, value}) {
        const searchParams = new URLSearchParams(location.getQueryParams());
        const formData: {[p: string]: any} = getFormDataSubmittingInFilterBar();
        EventBus.getInstance().emit(new OperationTypeSelectedEvent({
            name,
            value,
            isModalOpen: serpFiltersModal.isModalOpen(),
            formData,
            searchParams,
        }));
    })
}

export default {
    init,
}